import {
  LoginStatistics,
  ReportStatistics,
} from '@src/main/modules/common/statistics/domain/Statistics';
import { StatisticsRepository } from '@src/main/modules/common/statistics/domain/StatisticsRepository';

export const findLoginStatistics = async (
  repository: StatisticsRepository,
): Promise<LoginStatistics[]> => await repository.findAllLoginStatistics();

export const findReportsStatistics = async (
  repository: StatisticsRepository,
): Promise<ReportStatistics[]> => await repository.findAllReportsStatistics();
